import i from"styled-components";import{theme as o}from"../../../theme.js";const e=i.div`
  background-color: ${o.colors.primary[500]};
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  .navbar-container {
    width: ${o.maxWidth};
    margin: auto;
    height: 64px;
    box-sizing: border-box;
    @media screen and (max-width: ${o.breakpoints.xl}) {
      width: 100%;
    }
  }
  .desktop, .mobile {
    height: 100%;
  }
  .desktop {
    display: block
  }
  .mobile {
    display: none;
  }
  @media screen and (max-width: ${o.breakpoints.md}) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
  }
`;export{e as Container};
